import type { OutboxChange } from "../storage/indexed-db.ts";

export function syncBatch(outbox: OutboxChange[]): OutboxChange[] {
  const selected: OutboxChange[] = [];
  const processed = new Set<string>();
  for (const change of outbox) {
    if (change.batchId && processed.has(change.batchId)) continue;
    const group = change.batchId ? outbox.filter(item => item.batchId === change.batchId) : [change];
    if (selected.length + group.length > 250) break;
    selected.push(...group);
    if (change.batchId) processed.add(change.batchId);
  }
  return selected;
}
